import React from "react";
import clsx from "clsx";
import SeasonBuilderErrors from "../SeasonBuilderErrors";
import AddButtonNew from "../../AddButton/AddButtonNew";
import SeasonalPriceBuilder from "../../SeasonalPriceBuilder/SeasonalPriceBuilder";

class SeasonBuilderRoomTypes extends React.Component {
  constructor(props) {
    super(props);

    this.onAddSeasonalPrice = this.onAddSeasonalPrice.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onRemoveSeasonalPrice = this.onRemoveSeasonalPrice.bind(this);
  }

  render() {
    
    var self = this;

    var tabClasses = clsx({
      active: this.props.activeTab == "room_types",
      "tab-pane": true,
    });

    var seasonal_price_index = 0;
    var seasonal_prices = this.props.seasonal_prices.map(
      (seasonal_price, idx) => {
        if (!seasonal_price._destroy) {
          var errors = this.returnErrors(seasonal_price.room_type_price_id);

          return (
            <div className="panel-body container" key={idx}>
              <SeasonalPriceBuilder
                key={seasonal_price.id || self.generateId()}
                {...seasonal_price}
                errors={errors}
                onChange={self.onChange.bind(this, seasonal_price.id)}
                onRemove={self.onRemoveSeasonalPrice}
                index={seasonal_price_index++}
                nested={true}
                date_format={self.props.date_format}
                time_format={self.props.date_format}
                read_only={self.props.read_only}
                view_type="room_type_price"
                onChangeAllDays={this.props.onChangeAllDays}
                onChangeAllMinimumStays={this.props.onChangeAllMinimumStays}
              />
            </div>
          );
        }
      }
    );

    return (
      <div className={tabClasses}>
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default" style={{ marginBottom: 0 }}>
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6">
                  <h3 className="panel-title">
                    {I18n.t("group_contract_prices")}{" "}
                    <span
                      className="ss-help help"
                      title={I18n.t("seasonal_prices_helper_text")}
                    ></span>
                  </h3>
                </div>
                <div className="col-md-6 content-right flexed">
                  <AddButtonNew
                    key={this.props.season_id || self.generateId()}
                    disabled={this.props.disabled}
                    new_button={false}
                    model="RoomType"
                    text={I18n.t("add")}
                    ids={
                      this.props.seasonal_prices
                        ? this.props.seasonal_prices.map((seasonal_price) => {
                            return seasonal_price.room_type_id;
                          })
                        : null
                    }
                    onAdd={self.onAddSeasonalPrice}
                    view_type="room_type_price"
                    buttonClasses="btn btn-secondary"
                    generalPosition="left"
                  />
                </div>
              </div>
              {seasonal_prices.length ? (
                seasonal_prices
              ) : (
                <div className="no-records">
                  <span className="none">{I18n.t("none")}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * Change handlers
   */

  onAddSeasonalPrice(season) {
    var seasonal_prices = this.props.seasonal_prices.slice(0);
    var seasonal_price = {
      id: this.generateId(),
      season: season,
      season_id: season ? season.id : "-0",
      room_type: season.room_type || season,
      room_type_id: season.room_type_id,
      room_type_price: season.room_type_price,
      room_type_price_id: season.room_type_price_id,
    };

    seasonal_prices.unshift(seasonal_price);
    this.props.onChangeSeasonalPrices(seasonal_prices);
  }

  onChange(seasonal_price_id, seasonal_price) {
    var seasonal_prices = this.props.seasonal_prices.slice(0);
    var idx = this.getSeasonalPriceIndexById(seasonal_price_id);

    seasonal_price.season_id = this.props.season_id;

    seasonal_prices[idx] = seasonal_price;
    this.props.onChangeSeasonalPrices(seasonal_prices);
  }

  onRemoveSeasonalPrice(seasonal_price_id) {
    var seasonal_prices = this.props.seasonal_prices.slice(0);
    var idx = this.getSeasonalPriceIndexById(seasonal_price_id);

    if (idx >= 0) {
      seasonal_prices[idx]._destroy = true
      this.props.onChangeSeasonalPrices(seasonal_prices);
    }
  }

  /**
   * Helper functions
   */

  getSeasonalPriceIndexById(id) {
    for (var i = 0, ilen = this.props.seasonal_prices.length; i < ilen; i++) {
      if (this.props.seasonal_prices[i].id == id) {
        return i;
      }
    }
  }

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return "-" + text;
  }

  returnErrors(room_type_price_id) {
    var errors = SeasonBuilderErrors.roomTypesErrors(this.props.errors);
    var returnErrors = null;
    for (var i = 0; i < errors.length; i++) {
      if (Object.keys(errors[i])[0] === room_type_price_id) {
        returnErrors = Object.values(errors[i])[0];
      }
    }
    return returnErrors;
  }
}

export default SeasonBuilderRoomTypes;
